import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';
import type { ReactNode } from 'react';

const ATTRIBUTES = new Set(['product', 'graphics', 'story', 'structure', 'conceptual']);

const PILL_SX = {
  p: 1.5,
  borderRadius: 1,
  bgcolor: 'background.platform',
  color: 'action.active',
  fontSize: 10,
  fontWeight: 700,
  flexShrink: 0,
  whiteSpace: 'nowrap',
};

export const PRIMARY_PILL_SX = { bgcolor: 'primary.bg', color: 'primary.main' };

export const STATUS_PILL_SX: Partial<Record<string, typeof PRIMARY_PILL_SX>> = {
  running: PRIMARY_PILL_SX,
  failed: { bgcolor: 'background.platform', color: 'error.main' },
};

export const CHECKBOX_SX = {
  p: 0,
  '&.Mui-checked, &.MuiCheckbox-indeterminate': { color: 'common.black' },
};

export function attributePillSx(attribute: string): SxProps<Theme> {
  const key = attribute.toLowerCase();
  if (!ATTRIBUTES.has(key)) return {};
  return {
    bgcolor: `attribute.${key}.bg`,
    color: `attribute.${key}.main`,
  };
}

export function Pill({ children, sx }: { children: ReactNode; sx?: SxProps<Theme> }): ReactNode {
  return <Box sx={[PILL_SX, ...(Array.isArray(sx) ? sx : [sx])]}>{children}</Box>;
}
